import RestrictedAccessExplanation from './RestrictedAccessExplanation/RestrictedAccessExplanation';
import Explanation from './Explanation/Explanation';

export { RestrictedAccessExplanation };
export default Explanation;
